import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../components/ProductForm/types";
import { useLazyQuery } from "@apollo/client";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { BarcodeLookupResult } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_LOOKUP_BARCODE } from "./constants";
import React from "react";

export const useProductFormBarcodeLookup = () => {
  const { setValue, getValues } = useFormContext<ProductFormValues>();

  const flashMessagesContext = useFlashMessages();

  const [queryBarcodeLookup, { loading }] = useLazyQuery<{
    lookupBarcode: BarcodeLookupResult;
  }>(QUERY_LOOKUP_BARCODE);

  const handleOnBarcodeLookup = React.useCallback(
    async ({
      onFailCallback,
      onSuccessCallback,
    }: {
      onSuccessCallback?: () => void;
      onFailCallback?: () => void;
    } = {}) => {
      if (loading || !getValues("stockNumber")) return;

      const result = await queryBarcodeLookup({
        variables: {
          input: {
            barcode: getValues("stockNumber"),
          },
        },
      });

      if (
        result.data?.lookupBarcode &&
        "product" in result.data.lookupBarcode
      ) {
        if (!result.data.lookupBarcode.product) {
          if (onFailCallback) {
            onFailCallback();
          } else {
            flashMessagesContext.showMessage({
              message: `No product found with barcode ${getValues(
                "stockNumber"
              )}`,
              severity: "error",
            });
          }
        } else {
          setValue("name", result.data.lookupBarcode.product.name, {
            shouldValidate: true,
            shouldDirty: true,
          });
          setValue(
            "description",
            result.data.lookupBarcode.product.description ?? "",
            {
              shouldValidate: true,
              shouldDirty: true,
            }
          );
          onSuccessCallback?.();
        }
      } else {
        flashMessagesContext.showMessage({
          message: "Opps! Something went wrong",
          severity: "error",
        });
      }
    },
    [getValues, setValue, queryBarcodeLookup, loading]
  );

  return {
    loading,
    handleOnBarcodeLookup,
  };
};
